<div>
  @if (activeStepComponent()) {
    <div #dynamicComponentContainer class="dynamic-component-container"></div>
  } @else {
    <p class="text-sm text-surface-400">{{ 'project.content.body.noActiveStep' | transloco }}</p>
  }
</div>
